import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DrawerDetails } from "@shared/models/common";
import { Panel } from "primeng/panel";


@Component({
    selector: 'info-details',
    templateUrl: './info-details.component.html',
    styleUrls: ['./info-details.component.scss'],
    standalone: false
})
export class InfoDetailsComponent implements OnInit {

    @Input() details: DrawerDetails;

    @Input() isExpanded: boolean = false;

    @Input() label: string = 'Details';
    
    ngOnInit(): void {}

      onClose() {
       
        this.details = null;
    }

}